import { UsersApi, GetUsersResponse, UserUpdatePayload, UserCreatePayload } from '../api/usersApi';
import { User } from '../types/users.types';

export const createUsersService = (usersApi: UsersApi) => ({
  getUsers: async (
    offset: number = 0,
    limit: number = 50,
    orderBy?: [string, string][],
    query: unknown[] = [],
    quicksearch?: string,
  ): Promise<GetUsersResponse> => {
    const response = await usersApi.getUsers(offset, limit, orderBy, query, quicksearch);
    return {
      users: response.users,
      totalCount: response.totalCount,
    };
  },

  updateUser: async (userId: number, payload: UserUpdatePayload): Promise<User> => {
    return await usersApi.updateUser(userId, payload);
  },

  resetPassword: async (email: string): Promise<void> => {
    return await usersApi.resetPassword(email);
  },

  checkLoginExists: async (login: string): Promise<boolean> => {
    return await usersApi.checkLoginExists(login);
  },

  /** Whether a user other than `excludeUserId` already has this email. */
  isEmailInUse: async (email: string, excludeUserId?: number): Promise<boolean> => {
    const ids = await usersApi.findUserIdsByEmail(email);
    return ids.some((id) => String(id) !== String(excludeUserId));
  },

  createUser: async (payload: UserCreatePayload): Promise<User> => {
    return await usersApi.createUser(payload);
  },

  deleteUser: async (userId: number): Promise<void> => {
    return await usersApi.deleteUser(userId);
  },
});

export type UsersService = ReturnType<typeof createUsersService>;
